import styled from 'styled-components/macro';

export const Container = styled.div`
    margin: 0px auto;
    font-family: Roboto;
    background-color: #fff;
    border: 1px solid #e0e0e0;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border-radius: 10px;
    max-width: 80vw;
    @media screen and (max-width: 700px) {
        margin-top: 50px;
        margin-bottom: 50px;
        max-width: 94vw;
    }
`;

export const ContainerRow = styled.div`
    display: grid;
    grid-template-areas: 'column1 column1 column3';
    grid-auto-columns: 1fr;
    border-bottom: 1px solid #e0e0e0;
    @media (max-width: 1280px) {
        grid-template-areas:
            'column1'
            'column3';
    }
`;

export const Column1 = styled.div`
    grid-area: column1;
    grid-template-areas:
        'row1'
        'row2'
        'row3';
    padding-bottom: 20px;
    @media (min-width: 760px) and (max-width: 970px) {
        padding-bottom: 0;
    }
    @media (max-width: 759px) {
        padding: 0;
        justify-content: center;
        text-align: center;
    }
`;

export const Column3 = styled.div`
    grid-area: column3;
    border-left: 1px solid #e0e0e0;
    @media (max-width: 759px) {
        border-left: none;
    }
`;

export const Title = styled.div`
    display: grid;
    grid-area: title;
    display: inline-block;
    font-size: 22px;
    font-family: 'Roboto';
    font-weight: 500;
    color: #444449;
    padding: 10px 10px 10px 18px;
    @media (max-width: 760px) {
        text-align: center;
        font-family: 'Roboto', 'sans-serif';
    }
`;

export const InvisibleContainer = styled.div`
    height: 46px;
`;

export const Row1 = styled.div`
    grid-area: row1;
    border-bottom: 1px solid #e0e0e0;
    padding: 30px;
    @media (max-width: 370px) {
        padding: 30px 0;
    }
`;

export const Row2 = styled.div`
    grid-area: row2;
    border-bottom: 1px solid #e0e0e0;
    padding: 30px;
    @media (max-width: 370px) {
        padding: 30px 0;
    }
`;

export const Row3 = styled.div`
    grid-area: row3;
    padding: 30px;
    @media (max-width: 1280px) {
        border-bottom: 1px solid #e0e0e0;
    }
    @media (max-width: 370px) {
        padding: 30px 0;
    }
`;
